import React from 'react'

const Platforms = () => {
    return (
        <div className='container-bg'>
            <div className='platforms-main'>
                <div>
                    <h1 className='section-heading'>Supported Platforms</h1>
                    <p>Codie currently supports problems from the following platforms</p>
                </div>
                <div className='platforms-container'>
                    <div>
                        <a href="https://leetcode.com" target="_blank" rel="noreferrer">Leetcode</a>
                    </div>
                    <div>
                        <a href="https://hackerrank.com" target="_blank" rel="noreferrer">Hackerrank</a>
                    </div>
                    <div>
                        <a href="https://algoexpert.io" target="_blank" rel="noreferrer">Algoexpert</a>
                    </div>
                    <div>
                        <a href="https://geeksforgeeks.org" target="_blank" rel="noreferrer">Geeksforgeeks</a>
                    </div>
                    <div>
                        <a href="https://interviewbit.com" target="_blank" rel="noreferrer">InterviewBit</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Platforms